import React, { useState } from 'react';
import Moment from 'moment';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  MenuItem,
  DialogActions,
  ListItemText,
  TextField,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import Button from '../../../components/Button';
import TimeSelect from '../../../components/TimeSelect';

function AvailabilityModal(props) {
  const {
    open,
    selectedAvailability,
    provider,
    tenancies,
    onClose,
    onSave,
    onDelete,
    onEventStartChange,
    onEventEndChange,
    onTenancyChange,
    // onTimeError,
    classes: { input, dialogFooter, action },
  } = props;

  const [validationErrors, setValidationErros] = useState({});
  const eventDate = Moment(selectedAvailability.start).format('L');
  const isTelemedicineAvailable = tenancies.find(
    (item) => item.location.toLowerCase() === 'telemedicine'
  );
  const telemedicineId = (isTelemedicineAvailable && isTelemedicineAvailable.id) ? isTelemedicineAvailable.id : "";
  const validate = () => {
    let valid = true;
    const nextValidationErrors = {};
    if (!(provider && provider.name)) {
      valid = false;
      nextValidationErrors.providerName = 'Required';
    }
    if (!(selectedAvailability && selectedAvailability.tenancyId)) {
      valid = false;
      nextValidationErrors.tenancy = 'Required';
    }
    setValidationErros(nextValidationErrors);
    return valid;
  };

  return (
    <Dialog
      // disableBackdropClick
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
    >
      <DialogTitle>Availability</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          variant="outlined"
          label="Provider"
          name="providerName"
          value={provider.name}
          inputProps={{
            readOnly: true,
            disabled: true,
          }}
          error={validationErrors.providerName}
          helperText={validationErrors.providerName}
          className={input}
        />

        <TextField
          fullWidth
          variant="outlined"
          label="Date"
          name="date"
          value={eventDate}
          inputProps={{
            readOnly: true,
            disabled: true,
          }}
          className={input}
        />

        <FormControl fullWidth variant="outlined" className={input}>
          <TimeSelect
            label="From"
            time={selectedAvailability.start}
            onChange={(element) => onEventStartChange(element.target.value)}
          />
        </FormControl>
        {/* {onTimeError && (
          <>
            <span>{'No availablity for selected time'}</span>
          </>
        )} */}
        <FormControl fullWidth variant="outlined" className={input}>
          <TimeSelect
            label="To"
            time={selectedAvailability.end}
            onChange={(element) => onEventEndChange(element.target.value)}
          />
        </FormControl>

        <TextField
          fullWidth
          variant="outlined"
          label="Tenancy"
          name="tenancy"
          select
          value={selectedAvailability.tenancyId}
          onChange={(element) => {
            onTenancyChange(element.target.value, telemedicineId);
            setValidationErros({ ...validationErrors, tenancy: false });
          }}
          error={validationErrors.tenancy}
          helperText={validationErrors.tenancy}
          className={input}
        >
          {tenancies.map((tenancy) => {
            // the day view passes in providers who are caught off the practice,
            // and for some reason the providers here have tenancies without location (but with ids).
            // this is a temporary, surface level fix to NOT show any tenancies that are empty.
            if (!!tenancy.location) {
              return (
                <MenuItem value={tenancy.id} key={tenancy.id}>
                  <ListItemText primary={tenancy.location} />
                </MenuItem>
              );
            }
          })}
        </TextField>
      </DialogContent>

      <DialogActions className={dialogFooter}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          className={action}
        >
          Back
        </Button>
        {/* <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          className={action}
        >
          Update Schedule
        </Button> */}
        <div>
        {(selectedAvailability.scheduleId) ?
          <Button
            onClick={onDelete}
            onClickValidation={validate}
            variant="outlined"
            color="secondary"
            className={action}
          >
            Delete
          </Button>:''}

          <Button
            variant="contained"
            color="primary"
            className={action}
            onClickValidation={validate}
            onClick={onSave}
          >
            Save
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}

const styles = () => ({
  input: {
    margin: '0.5em 0',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#ADADAD',
  },
  action: {
    marginLeft: '5px',
  },
});

export default withStyles(styles)(AvailabilityModal);
